import styled from "styled-components";

export const StyledConditionalTooltipTextContainer = styled.div`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
    max-width: 100%;
    display: block;
`;
